// MY CLOSET (ITEM 1) — **the right-rail tab and its drawer, LAST of her nine.**
//
// The ROOM is `ClosetBody`; only the chrome is here, because `EdgeDrawer` closes over
// `useEscapeKey` and `CLOSE_OVERLAYS_EVENT` and there may be exactly one of it (R28/R29).
//
// **IT MOVED OUT OF App.tsx WITH `requireFeature` AS A PROP RATHER THAN AS A HOOK CALL**, which is
// what makes the move possible at all: `useRequireFeature` is App.tsx's own context hook, so a
// component that calls it cannot leave that file without importing back into the monolith. Taking
// the gate as a parameter keeps the entitlement check exactly where it was (this drawer still asks
// before it opens) and costs the caller one word.
//
// **RAIL RESTORE (her ruling, 2026-08-10) — THIS FILE WAS `RailMore.tsx` AND THE `More` TAB IS
// DELETED, NOT DISABLED** (DL-2/DT-2b/R181, and the file is RENAMED with it: a module named after a
// component it no longer contains is the same stale receipt one level up). Her law: the drawer rail
// shows every drawer individually, and grouping them needs her explicit word in advance. The
// `useRailDrawer` hook went with it — a tucked drawer needed an event because it had no tab of its
// own to open it by, and all nine have one again (R165: a law with no caller is deleted, not left
// exported to read as a capability the house has).
import { useState } from "react";
import { DrawerTab } from "./DrawerTab";
import { EdgeDrawer } from "./EdgeDrawer";
import { ClosetBody } from "./ClosetBody";
import { CLOSET_TITLE } from "../closet.js";

export function FloatingCloset({ requireFeature, language }: { requireFeature: (feature: string, action: () => void) => void; language: string }) {
  const [open, setOpen] = useState(false);
  return (
    <aside className="craft-drawer craft-drawer--closet" aria-label={CLOSET_TITLE}>
      <DrawerTab label={CLOSET_TITLE} onClick={() => (open ? setOpen(false) : requireFeature("journal", () => setOpen(true)))} />
      <EdgeDrawer open={open} onClose={() => setOpen(false)} label={CLOSET_TITLE} className="closet-drawer">
        {/* CLOSET-1: `language` is REQUIRED down to the send control (14-B6a/14-B7b's ruling on the
            shared sender), so a Spanish member is not handed one English button inside a drawer. */}
        <ClosetBody language={language} />
      </EdgeDrawer>
    </aside>
  );
}
